import {
  Button,
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import useSurrenderList from "./useSurrenderList";
import AddFormFieldsContainer from "./AddForm";
import Filter from "./Filter";
import AddRemark from "./AddRemark";

const SurrenderList = () => {
  const {
    surrendersList,
    surrender,
    currentPage,
    paginationOptions,
    isFetching,
    isLoading,
    refetch,
    handlePagination,
    handlePageSize,
    // handleDateChange,
    handleSort,
    handleSearch,
    getRow,
    handleEditClick,
    closeEditModal,
    showEditModal,
    handleDelete,
    handleAddsurrender,
    showform,
    setShowform,
    setIsFilterShow,
    isFilterShow,
    showDeleteConfirm,
    setShowDeleteConfirm,
    handleDeleteAction,
    handleEditAction,
    updateSurrendersFields,
    hasCreatePermission,
    hasDeletePermission,
    hasEditPermission,
    is_Cancelled,
    checkIsActive,
    user_type,
    handleAddNote,
    handleCloseNotesCk
  } = useSurrenderList();

  return (
    <>
      <HeadingGroup
        title={"Surrender list"}
        className={`pro-mb-4`}
        buttonTitle={hasCreatePermission ?? false ? "Add new" : ""}
        handleClick={() => {
          handleAddsurrender();
        }}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="row">
          <div className="col-10">
            <SearchFilters
              data={surrender?.data?.filters}
              onSearchInput={(e) => handleSearch(e)}
              showActions={true}
              loading={isLoading}
              handleActionClick={() => handleEditClick()}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
            />
          </div>
          <div className="col-auto pro-ms-auto">
            <Button
              onClick={() => {
                setIsFilterShow(true);
              }}
              className="pro-btn pro-btn-primary pro-px-5 lg"
            >
              Filter
            </Button>
          </div>
        </div>
        <Table
          multiSelect={false}
          data={surrendersList?.rows?.data}
          uniqueID={"id"}
          fields={surrendersList?.field}
          showCheckBox={(hasEditPermission || hasDeletePermission) ?? false}
          SortIcon={<FaSort />}
          handleSort={handleSort}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          deleteIcon={<span className="material-symbols-outlined">delete</span>}
          getRow={getRow}
          loading={isFetching}
          perpage={surrender.currentPageSize}
          handleEdit={handleEditAction}
          handleDelete={handleDelete}
          deletable={user_type == 1 ? true : false}
          assignable={((user_type == 1) || (is_Cancelled)) ? false : true}
          assignIcon={<span class="material-symbols-outlined">mail</span>}
          assignText={"Cancellation Request"}
          handleAssign={handleAddNote}
          handleSelect={checkIsActive}
          editable={hasEditPermission ?? false}
          // deletable={hasDeletePermission ?? false}
        />
        {surrendersList?.rows?.data?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPageCount={surrendersList?.rows?.last_page}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout show={showEditModal} handleClose={closeEditModal}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={surrendersList.field}
              moduleId={surrendersList.table_id}
              updateData={updateSurrendersFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          centered={false}
          show={showform}
          handleClose={() => {
            setShowform(false);
          }}
          backdrop="static"
          title={"Add Surrender"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <AddFormFieldsContainer setShowform={setShowform} />
        </OffCanvasLayout>
        <ModalLayout
          centered={false}
          show={showDeleteConfirm}
          handleClose={setShowDeleteConfirm}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={`Are you sure you want to delete?`}
              isRight={true}
              cancelText={`No`}
              submitText={`Yes`}
              cancelAction={setShowDeleteConfirm}
              submitAction={handleDeleteAction}
            >
              ConfirmationBox
            </ConfirmationBox>

            {true && <span className="error-message">{true}</span>}
          </div>
        </ModalLayout>
        <OffCanvasLayout
          centered={true}
          show={isFilterShow}
          handleClose={() => {
            setIsFilterShow(false);
          }}
          title={"Filter"}
          backdrop="static"
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <Filter setShowform={setIsFilterShow} />
        </OffCanvasLayout>

        <ModalLayout
          show={surrender.showNotesCk}
          handleClose={handleCloseNotesCk}
          title={"Add Remark"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
          backdrop="static"
        >
          <div className="pro-m-5">
            <AddRemark
              selectedItemData={surrender.selectedItemData}
              isStickyFooter
              refetch={refetch}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default SurrenderList;
